/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DaypartResult } from '../../models/daypart-result';
import { HalJson } from '../../models/hal-json';

export interface DaypartsGet$Params {
  'Active-Tenant-Identifier': string;
}

export function daypartsGet(http: HttpClient, rootUrl: string, params: DaypartsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
'_embedded'?: {
'dayparts'?: Array<DaypartResult>;
};
}>> {
  const rb = new RequestBuilder(rootUrl, daypartsGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      '_embedded'?: {
      'dayparts'?: Array<DaypartResult>;
      };
      }>;
    })
  );
}

daypartsGet.PATH = '/dayparts';
